import React from "react";

function IconPencil() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="#fff" />
      <path d="M20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" fill="#fff" />
    </svg>
  );
}

function IconClose() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M18 6L6 18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6l12 12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconSend() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M22 2L11 13" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 2l-7 20  -4-9-9-4 20-7z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function Alert({ image = "/assets/walkthrough/citizen_alert.svg", onNext }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.45)",
        zIndex: 9999,
        padding: "20px",
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Draft Alert Messaging"
    >
      <div
        style={{
          background: "#1e1e1e",
          borderRadius: 12,
          padding: 24,
          width: "80vw",
          maxWidth: "1200px",
          maxHeight: "80vh",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: 12 }}>
          <h2
            style={{
              margin: 0,
              color: "#f5f5f5",
              fontSize: 24,
              fontWeight: 700,
            }}
          >
            Draft Alert Messaging
          </h2>
        </div>

        {/* Inner content box (scrollable) */}
        <div
          style={{
            background: "#2b2b2b",
            borderRadius: 8,
            padding: 16,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 12,
            flex: 1,
            overflow: "auto",
            position: "relative",
          }}
        >
          {/* Alert preamble banner */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "8px 12px",
              background: "rgba(255,255,255,0.02)",
              borderRadius: 6,
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 6,
                background: "#c62828",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              aria-hidden
            >
              {/* small lightbulb/alert icon - simple SVG */}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M9 21h6" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
                <path d="M12 3a5 5 0 00-3 9v2h6v-2a5 5 0 00-3-9z" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div style={{ color: "#fff", fontWeight: 600 }}>Emergency Evacuation Alert</div>
          </div>

          {/* Simulated editable message area / composer */}
          <div style={{ display: "flex", gap: 16, alignItems: "center", padding: "12px"}}>
            {/* Illustration / image */}
              <img
                src={image}
                alt="citizen alert"
                style={{ width: "100%", height: "100%" }}
              />
          </div>

          {/* Footer buttons - sticky to bottom of the inner content box */}
          <div
            style={{
              position: "sticky",
              bottom: 0,
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              paddingTop: 8,
              background: "linear-gradient(180deg, rgba(43,43,43,0) 0%, rgba(43,43,43,0.6) 100%)",
            }}
          >
            <button
              aria-label="Edit"
              style={{
                width: 44,
                height: 44,
                borderRadius: 8,
                background: "#444",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={onNext}
            >
              <IconPencil />
            </button>

            <button
              aria-label="Close"
              style={{
                width: 44,
                height: 44,
                borderRadius: 8,
                background: "#222",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={onNext}
            >
              <IconClose />
            </button>

            <button
              aria-label="Send"
              style={{
                width: 44,
                height: 44,
                borderRadius: 8,
                background: "#2ecc71",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={onNext}
            >
              <IconSend />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Alert;
